import React, { FC } from 'react'
import { Col, useScreenClass } from 'react-grid-system'
import styled from 'styled-components'

const Section = styled.section<{ isDesktop: boolean }>`
  background-color: #002244;
  height: ${(props) => (props.isDesktop ? '380px' : 'auto')};
  padding: ${(props) => (props.isDesktop ? '4rem' : '7rem 1rem')};
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  text-align: center;       /* always center text */
`

const Content = styled.div<{ isDesktop: boolean }>`
  color: #fff;
  max-width: 300px;
  margin: 1rem;
  text-align: center;       /* center text inside each block */

  h3 {
    font-size: ${(props) => (props.isDesktop ? '36px' : '28px')};
    font-weight: 600;
    margin-bottom: 0.5rem;
    line-height: 1.2;
  }

  .content-large-text {
    font-size: ${(props) => (props.isDesktop ? '48px' : '34px')};
    font-weight: 700;
    margin: 0.5rem 0;
    line-height: 1.1;
  }

  p {
    font-size: ${(props) => (props.isDesktop ? '18px' : '16px')};
    margin: 0.25rem 0;
    line-height: 1.5;
  }
`

const ProgramDetails: FC = () => {
  const screenClass = useScreenClass()
  const isDesktop = ['lg', 'xl'].includes(screenClass)

  return (
    <Section isDesktop={isDesktop}>
      <Col xs={12} sm={12} lg={4}>
        <Content isDesktop={isDesktop}>
          <h3>It's Diverse</h3>
          <p className="content-large-text">We Go Global</p>
          <p>Remote learning options available</p>
        </Content>
      </Col>
      <Col xs={12} sm={12} lg={4}>
        <Content isDesktop={isDesktop}>
          <h3>Program Length</h3>
          <p className="content-large-text">8 Months</p>
          <p>September – May cohort</p>
        </Content>
      </Col>
      <Col xs={12} sm={12} lg={4}>
        <Content isDesktop={isDesktop}>
          <h3>It's Affordable</h3>
          <p className="content-large-text">$8,200</p>
          <p>Financial aid & payment plans</p>
        </Content>
      </Col>
    </Section>
  )
}

export default ProgramDetails
